import { DeliveryDetailsAction } from '../actions/DeliveryDetailsAction'
import { SequenceManagerAction } from '../actions/SequenceManagerAction'

const initState = {
    requestBody: {
        sectionId: "DeliveryDetails",
        steps: [
            {
                sequence: "0",
                stepId: "DeliveryDetails",
                fields: [
                    {
                        name: "Email",
                        value: ""
                    },
                    {
                        name: "Receiver Name",
                        value: ""
                    },
                    {
                        name: "Receiver Phone Number",
                        value: ""
                    },
                    {
                        name: "Delivery Address",
                        value: ""
                    },
                    {
                        name: "Delivery Notes",
                        value: ""
                    },
                    {
                        name: "Latitude",
                        value: ""
                    },
                    {
                        name: "Longitude",
                        value: ""
                    },
                    {
                        name: "DeliveryLocation Response",
                        value: ""
                    },
                    {
                        name: "ContactPhoneNumber",
                        value: ""
                    },
                    {
                        name: "National address",
                        value: ""
                    },
                    {
                        name: "ID number",
                        value: ""
                    },
                    {
                        name: "Address Consent",
                        value: ""
                    },
                    {
                        name: "PostalCode",
                        value: ""
                    },
                    {
                        name: "PoBox",
                        value: ""
                    },
                    {
                        name: "City",
                        value: ""
                    },
                    {
                        name: "Country",
                        value: ""
                    }
                ]
            }
        ],
    },
    deliveryCheckResponse: {

    },
    initiateOTPResponse: {

    },
    validateOTPResponse: {

    },
    rSendOTPResponse: {

    },
    currLoc: {

    },
}

const DeliveryDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var DeliveryDetailsValue = { ...state.requestBody.steps };

    switch (type) {
        case DeliveryDetailsAction.DELIVERY_OTP_INITIATE_SUCCESS:
            return { ...state, initiateOTPResponse: payload };

        case DeliveryDetailsAction.DELIVERY_OTP_VALIDATE_SUCCESS:
            return { ...state, validateOTPResponse: payload };

        case DeliveryDetailsAction.DELIVERY_OTP_RSEND_SUCCESS:
            return { ...state, rSendOTPResponse: payload };

        case DeliveryDetailsAction.DELIVERY_DETAILS_SUCCESS:
            DeliveryDetailsValue[0].fields[0].value = payload.email;
            DeliveryDetailsValue[0].fields[1].value = payload.name;
            DeliveryDetailsValue[0].fields[2].value = payload.phone;
            DeliveryDetailsValue[0].fields[3].value = payload.address;
            DeliveryDetailsValue[0].fields[4].value = payload.notes;
            DeliveryDetailsValue[0].fields[8].value = payload.contactPhone;
            DeliveryDetailsValue[0].fields[9].value = payload.nationalAddress;
            DeliveryDetailsValue[0].fields[10].value = payload.natId;
            DeliveryDetailsValue[0].fields[11].value = payload.isConsentBoxChecked === true ? "true" : "";
            DeliveryDetailsValue[0].fields[12].value = payload.natPostalCode;
            DeliveryDetailsValue[0].fields[13].value = payload.natPoBox;
            DeliveryDetailsValue[0].fields[14].value = payload.nationalCityName;
            DeliveryDetailsValue[0].fields[15].value = payload.nationalName;
            return { ...state, currLoc: payload.currLoc };

        case DeliveryDetailsAction.DELIVERY_CHECK_SUCCESS:
            DeliveryDetailsValue[0].fields[5].value = payload.lat;
            DeliveryDetailsValue[0].fields[6].value = payload.lng;
            DeliveryDetailsValue[0].fields[7].value = JSON.stringify(payload.response);
            return { ...state, deliveryCheckResponse: payload.response };

        case SequenceManagerAction.DISPLAY_PREVIOUS_SECTION:
        case SequenceManagerAction.DISPLAY_SECTION:
            return { ...state, deliveryCheckResponse: {}, initiateOTPResponse: {}, validateOTPResponse: {}, rSendOTPResponse: {} }

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'DeliveryDetails')
            });
            if (section.length > 0) {
                for (let i = 0; i < DeliveryDetailsValue[0].fields.length; i++) {
                    const DeliveryDetailsField = section[0].steps[0].fields.filter((field: any) => { return (field.name === DeliveryDetailsValue[0].fields[i].name) })[0];
                    DeliveryDetailsValue[0].fields[i].value = DeliveryDetailsField ? DeliveryDetailsField.value : "";
               }
            }
            return state;

        default:
            return state;
    }
}

export default DeliveryDetailsReducer;